export default "__VITE_ASSET__BokWdZpW__"